import { Inject, Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ALAIN_I18N_TOKEN, MenuService, SettingsService, TitleService } from '@delon/theme';
import { DA_SERVICE_TOKEN, ITokenService } from '@delon/auth';
import { ACLService } from '@delon/acl';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { I18NService } from '../i18n/i18n.service';
import { JySystemConfigService } from '../../routes/jy-commons/system-config/jy-system-config.service';
import { JyMenuService } from '../../routes/jy-authorization/menu/jy-menu.service';
import { JyUserService } from '../../routes/jy-authorization/user/jy-user.service';
import { PersonService } from '../../routes/jy-org/person/service/person.service';
import { SrmMenuService } from '@shared/components/srm-menu/srm-menu.service';
import {NzMessageService} from "ng-zorro-antd";

/**
 * 用于应用启动时
 * 一般用来获取应用所需要的基础数据等
 */
@Injectable()
export class StartupService {
  constructor(private jySystemConfigService: JySystemConfigService,
              private jyUserService: JyUserService,
              private jyMenuService: JyMenuService,
              private menuService: MenuService,
              private translate: TranslateService,
              @Inject(ALAIN_I18N_TOKEN) private i18n: I18NService,
              private settingService: SettingsService,
              private aclService: ACLService,
              private titleService: TitleService,
              @Inject(DA_SERVICE_TOKEN) private tokenService: ITokenService,
              private httpClient: HttpClient,
              private injector: Injector,
              private srmMenuService: SrmMenuService,
              private personService: PersonService
  ) {
    //  配置title名
    this.titleService.default = '王力SRM平台';
  }

  getQueryString() {
    let name,value;
    let str=location.href;  //取得整个地址栏
    let num=str.indexOf("?");
    str=str.substr(num+1); //str得到?之后的字符串

    let arr=str.split("&"); //得到&分割的参数，放入数组中
    for(let i=0;i<arr.length;i++)
    {
      num=arr[i].indexOf("=");
      if(num>0)
      {
        name=arr[i].substring(0,num);
        value=arr[i].substr(num+1);
        this[name]=value;
      }
    }
  }

  public oaWindowBol:boolean = false;
  private getSystemInfo(resolve: any, reject: any) {

    this.i18n.use(this.i18n.defaultLang);
    this.jySystemConfigService.getSystemInfo()
      .subscribe((systemInfo) => {
          if (systemInfo) {
            // application data
            const res: any = systemInfo;
            // 应用信息：包括站点名、描述、年份
            this.settingService.setApp(systemInfo);
            // ACL：设置权限为全量
            this.aclService.setFull(true);
            // 设置页面标题的后缀
            this.titleService.suffix = res.name;
          }
          let windowUrl = window.location.href;
          if(windowUrl.indexOf('pur-requisition/query') > -1 || windowUrl.indexOf('pur-requisition/todo') > -1){
            let winParm = new this.getQueryString();
            if(winParm['oaNew'] && winParm['oaUserId']){
              this.jyUserService.getToken(winParm['oaUserId']).subscribe((res) => {
                this.oaWindowBol = true;
                if(res.status === 'success'){
                  this.tokenService.set({
                    token: res.msg,
                  });
                }else{
                  this.tokenService.clear();
                  this.injector.get(NzMessageService).error(res.msg,{nzDuration:5000});
                }
                localStorage.removeItem('lockBol');//清楚锁屏状态
                resolve({});
              },()=>{
                this.tokenService.clear();
                resolve({});
              });
            }else{
              resolve({});
            }
          }else{
            resolve({});
          }
        },
        () => {
          resolve({});
        },
        () => {

        });
    // this.i18n.change.subscribe(() => {
    //   this.loadUserData();
    // this.personService.getAndSetCurrentPerson();
    // })
  }

  loadSystemInfo(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.getSystemInfo(resolve, reject);
    });
  }

  loadUserData(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.getUserData(resolve, reject);
    });
  }

  //重新加载菜单待办数据
  public reloadMenuTodoData() {
    this.getTodoData(this.menuService.menus);
  }

  //获取待办数据
  getTodoData(menus) {
    let configMenus = [];
    this.getMenuConfigMenus(configMenus, menus);
    let configMenuIds = configMenus.map(menu => menu.configMenuId);
    if (configMenuIds == null || configMenuIds.length < 1) {
      return;
    }
    this.srmMenuService.getAgendaCountData(configMenuIds).subscribe(data => {
      for (let i = 0; i < configMenus.length; i++) {
        let configMenu = configMenus[i];
        for (let j = 0; j < data.length; j++) {
          let item = data[j];
          if (configMenu.configMenuId == item.id) {
            configMenu.badge = item.agendaNum;
          }
        }
      }
      this.menuService.resume();
    });
  }

  //递归获取菜单中的有配置待办的菜单
  getMenuConfigMenus(configMenus, menus) {
    for (let i = 0; i < menus.length; i++) {
      let menu = menus[i];
      if (menu.configMenuId) {
        configMenus.push(menu);
      }
      if (menu.children) {
        this.getMenuConfigMenus(configMenus, menu.children);
      }
    }
  }

  private getUserData(resolve: any, reject: any) {
    // const tokenData = this.tokenService.get();
    // if (!tokenData.token) {
    //   this.injector.get(Router).navigateByUrl('/passport/login');
    //   resolve({});
    //   return;
    // }

    this.jyUserService.current().subscribe((userData) => {
      // const user: any = {
      //   name: 'Admin',
      //   avatar: './assets/tmp/img/avatar.jpg',
      //   email: 'cipchk@qq.com',
      //   token: '123456789'
      // };
      // 用户信息：包括姓名、头像、邮箱地址
      if (userData) {
        this.settingService.setUser(userData);
      } else {
        this.injector.get(Router).navigateByUrl('/passport/login');
      }
      // ACL：设置权限为全量
      this.aclService.setFull(true);
      // 初始化菜单
      this.jyMenuService.current().subscribe((menus) => {
          if (menus) {
            this.menuService.add(menus);
            this.getTodoData(menus);
          }
        },
        () => {
        },
        () => {
          resolve({});
        },
      );
    });
  }
}
